<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileDisaplayNormals',
})
</script>
<template>
  <Row :gutter="[16, 16]" v-if="files.length">
    <Col v-for="item in files" :key="item.id" v-bind="colAttrs">
      <FileDisplayNormal :record="item" :viewRaw="viewRaw" :closeable="closeable" @del="() => $emit('del', item.id!)" />
    </Col>
  </Row>
</template>

<script lang="ts" setup name="FileDisaplayNormals">
import { Col, Row } from 'ant-design-vue'
import { fileDisplayNormalsProps } from './props'
import FileDisplayNormal from './Normal.vue'

defineProps(fileDisplayNormalsProps)
defineEmits<{
  (e: 'del', id: string): void
}>()
</script>
